import { createContext } from 'react';

const IpStatusContext = createContext('');

export default IpStatusContext;
